import { lastBookingTable } from "../../config.json";

class LastBookingAccess {

  static add = async (db, personDbId, tableName, data) => {
    if (!db) return null;
    if (!tableName) return null;

    data["name"] = `${personDbId}_${tableName}`;
    console.log("add: data=", data);

    await db.add(lastBookingTable, data);

    return true;
  };

  static getByPersonAndTable = async (db, personDbId, tableName) => {

    if (!db) return null;
    if (!tableName) return null;

    try {
      return await db.getFromIndex(lastBookingTable, "name", `${personDbId}_${tableName}`);
    } catch (ex) {
      console.log(ex);
      return null;
    }
  };

  static updateByPersonAndTable = async (db, personDbId, tableName, data) => {

    if (!db) return null;
    if (!tableName) return null;

    const savedData = await db.getFromIndex(lastBookingTable, "name", `${personDbId}_${tableName}`);
    if (savedData["id"]) {
      data["id"] = savedData["id"];
      data["name"] = `${personDbId}_${tableName}`;

      const tx = db.transaction(lastBookingTable, "readwrite");
      let objectStore = await tx.objectStore(lastBookingTable);

      const updateRequest = await objectStore.put({...data});

      await tx.done;
    }

  };

}

export default LastBookingAccess;

